/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Note_Mention_TitleInputs */

const en_notifications_note_mention_title = /** @type {(inputs: Notifications_Note_Mention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentioned in a case note`)
};

const pt_br2_notifications_note_mention_title = /** @type {(inputs: Notifications_Note_Mention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menção em nota do caso`)
};

/**
* | output |
* | --- |
* | "Mentioned in a case note" |
*
* @param {Notifications_Note_Mention_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_note_mention_title = /** @type {((inputs?: Notifications_Note_Mention_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Note_Mention_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_note_mention_title(inputs)
	return pt_br2_notifications_note_mention_title(inputs)
});